export default "__VITE_ASSET__bbbfd1f8__"